import React, {useEffect, useState} from "react";

import VLFModal from "@/components/Modal";
import VLFDatePicker from "@/components/Input/DatePicker";
import VLFTextField from "@/components/Input/TextField";

import {REQUIRED_FIELD} from "@/utils/constants";
import {checkRequiredFields} from "@/utils/functions";

function HandleAgentModal(props) {
	const {open, initialData, confirm, close} = props;

	const [formData, setFormData] = useState({});
	const [errors, setErrors] = useState([]);

	useEffect(() => {
		if (initialData) {
			setFormData(initialData);
		}
	}, [initialData]);

	useEffect(() => {
		if (!open) {
			setFormData({});
		}
	}, [open]);

	const getRequiredFields = () => {
		const requiredFields = ["dateFrom", "name"];

		return requiredFields;
	};

	return (
		<VLFModal
			maxWidth="md"
			open={open}
			title={initialData ? "Modifica informazione" : "Aggiungi informazione"}
			close={close}
			confirm={() => {
				const errors = checkRequiredFields(getRequiredFields(), formData);
				setErrors(errors);

				if (!errors.length) {
					confirm(
						{
							...formData,
						},
						initialData?.id,
					);
				}
			}}
			content={
				<div className="row">
					<div className="col-12 col-sm-6">
						<VLFDatePicker
							label="Data"
							value={formData.dateFrom}
							onChange={(value) => {
								setErrors([]);
								setFormData({...formData, dateFrom: value});
							}}
							required
							format="DD-MM-YYYY"
							size="small"
							helperText={
								errors.indexOf("dateFrom") !== -1 ? REQUIRED_FIELD : ""
							}
							error={errors.indexOf("dateFrom") !== -1}
						/>
					</div>
					<div className="col-12 col-sm-6">
						<VLFTextField
							name="name"
							value={formData.name || ""}
							onChange={(event) => {
								setErrors([]);
								setFormData({...formData, name: event.target.value});
							}}
							label="Nome"
							size="small"
							helperText={errors.indexOf("name") !== -1 ? REQUIRED_FIELD : ""}
							error={errors.indexOf("name") !== -1}
						/>
					</div>
					<div className="col-12">
						<VLFTextField
							value={formData.notes || ""}
							onChange={(e) => {
								setFormData({...formData, notes: e.target.value});
							}}
							label="Note"
							size="small"
							multiline
							minRows={3}
							maxRows={3}
						/>
					</div>
				</div>
			}
		/>
	);
}

export default HandleAgentModal;
